import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { TranslateDropdown } from "./TranslateDropdown";
import { useTranslate } from "../context/TranslateContext";

const ROUTES = { Movies: "/movies", "Film Locations": "/locations", "My Cinema": "/my-cinema", "Music Charts": "/charts" };

const COLS = [
  { head: "Discover", items: ["Movies", "Music Charts", "People", "Trailers", "Reviews", "Box Office"] },
  { head: "Explore", items: ["Cinema History", "Encyclopedia", "Film Locations", "Festivals", "Awards", "OTT Guide"] },
  { head: "Participate", items: ["My Cinema", "Community", "CinemaPulse", "Industry Directory", "Submit Content", "Newsletter"] },
];

const ECOSYSTEM = ["Indias.com", "Kerala.com", "My Social Pulse", "FamilyTree.team"];

export const Footer = () => {
  const { t } = useTranslate();

  return (
    <footer className="relative border-t border-edge bg-surface/30" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-display text-4xl font-semibold text-cream md:text-5xl">Indias</span>
              <span className="font-display text-4xl font-semibold italic text-gradient-gold md:text-5xl">Cinema</span>
            </div>
            <p className="mt-6 max-w-md font-body text-lg leading-relaxed text-ash">
              {t("The global home for Indian cinema, music and the people behind it. Discover, listen, and belong — in every language.")}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <TranslateDropdown testId="footer-translate" />
              
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.head} className="lg:col-span-2">
              <div className="font-body text-xs uppercase tracking-[0.25em] text-gold">{t(c.head)}</div>
              <ul className="mt-5 space-y-3">
                {c.items.map((it) => (
                  <li key={it}>
                    {ROUTES[it] ? (
                      <Link to={ROUTES[it]} data-testid={`footer-link-${it.toLowerCase().replace(/ /g, "-")}`} className="font-body text-sm text-ash transition-colors duration-300 hover:text-gold">{t(it)}</Link>
                    ) : (
                      <a href="#top" className="font-body text-sm text-ash transition-colors duration-300 hover:text-cream">{t(it)}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 border-t border-edge pt-8">
          <div className="mb-6 flex flex-wrap items-center gap-3">
            <span className="font-body text-xs uppercase tracking-[0.2em] text-ash">{t("Part of the ecosystem")}</span>
            {ECOSYSTEM.map((e) => (
              <motion.a key={e} href="#top" whileHover={{ y: -2 }}
                className="inline-flex items-center gap-1 rounded-full border border-edge px-3 py-1.5 font-body text-xs text-cream transition-colors duration-300 hover:border-gold hover:text-gold">
                {e} <ArrowUpRight className="h-3 w-3" />
              </motion.a>
            ))}
          </div>
          <div className="flex flex-col justify-between gap-3 md:flex-row">
            <span className="font-body text-xs text-ash">© 2026 IndiasCinema.com · {t("Built for a billion stories")}</span>
            <div className="flex gap-6">
              {["Privacy", "Terms", "Accessibility", "Contact"].map((l) => (
                <a key={l} href="#top" className="font-body text-xs text-ash transition-colors hover:text-gold">{t(l)}</a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
